import React, { lazy } from 'react';
import queryString from 'query-string';
import PrivateRoute from 'PrivateRoutes';
// import { Sounds } from './components';
const Sounds = lazy (() => import(/* webpackChunkName: "Sounds" */'./components'));
const moduleList = ({ location }) => {
  const queryParams = queryString.parse(location.search);
  console.log('queryParams', queryParams);
  return <Sounds moduleId={queryParams.id} />;
};

const routes = () => (
  <PrivateRoute exact path="/settings/sounds" component={moduleList} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/Sounds/routes.js